import TextField from "@mui/material/TextField";

const CustomTextField = ({
  label,
  value,
  onChange,
  placeholder,
  fullWidth = true,
  size = "small",
  type = "text",
  ...props
}) => {
  return (
    <TextField
      label={label}
      type={type}
      size={size}
      fullWidth={fullWidth}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={onChange}
      sx={{
        "& .MuiInputLabel-root": {
          color: "#7c7c7d !important",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#7c7c7d !important",
        },
        "& .MuiOutlinedInput-root": {
          height: "40px !important",
          borderRadius: "10px",
          padding: "0 12px",

          "& fieldset": {
            borderColor: "#CDCDCF",
          },
          "&:hover fieldset": {
            borderColor: "#CDCDCF",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#333 !important",
            borderWidth: "1px !important",
          },
        },
        "& .MuiInputBase-input": {
          height: "40px !important",
          padding: "0 !important",
          display: "flex",
          alignItems: "center",
          "&::placeholder": {
            color: "#7c7c7d",
            opacity: 1,
            fontSize: "14px !important",
          },
        },
        "& .MuiSelect-select": {
          height: "40px !important",
          display: "flex",
          alignItems: "center",
          paddingRight: "24px !important",
        },
      }}
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  );
};

export default CustomTextField;
